'use client';

import { useState } from 'react';
import Image from 'next/image';
import { IconArrowBarRight, IconBell, IconHelp } from '@tabler/icons-react';
import { signOut } from 'aws-amplify/auth';
import { Burger, Container, Group, Menu } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import logo from '@/assets/aws-logo.png';
// import profile_pic from '@/assets/profile_pic.png';
import profile_pic from '@/assets/slalom_icon.png';
import styles from './header.module.css';

const leftLinks = [
  { link: '/mapOverview', label: 'Map Overview', icon: null },
  { link: '/performance', label: 'Performance', icon: null },
];

const iconLinks = [
  { link: '/notifications', label: null, icon: <IconBell size={24} /> },
  { link: '/info', label: null, icon: <IconHelp size={24} /> },
];

export function Header() {
  const [opened, { toggle }] = useDisclosure(false);
  const [active, setActive] = useState(leftLinks[0].link);

  const mapOverviewAndPerformance = leftLinks.map((link) => (
    <a
      key={link.link}
      href={link.link}
      className={styles.link}
      data-active={active === link.link || undefined}
      onClick={(event) => {
        event.preventDefault();
        setActive(link.link);
      }}
    >
      <span className={styles.icon}>{link.icon}</span>
      {link.label}
    </a>
  ));

  const iconItems = iconLinks.map((link) => (
    <a
      key={link.link}
      href={link.link}
      data-active={active === link.link || undefined}
      onClick={(event) => {
        event.preventDefault();
        setActive(link.link);
      }}
    >
      <span className={styles.icon}>{link.icon}</span>
    </a>
  ));

  return (
    <header className={styles.header}>
      <Container size="md" className={styles.inner}>
        <div className={styles.logoAndLeftItems}>
          <Image src={logo} alt="AWS Logo" width={47} height={28} className={styles.logo} />
          <Group
            wrap="nowrap"
            gap={12}
            visibleFrom="sm"
            className={styles.mapOverviewAndPerformance}
          >
            {mapOverviewAndPerformance}
          </Group>
        </div>

        <Group wrap="nowrap" gap={0} visibleFrom="sm">
          {iconItems}
          <Menu position="bottom-end" width={140} withArrow arrowPosition="center" offset={20}>
            <Menu.Target>
              <Image
                src={profile_pic}
                alt="Profile"
                width={36}
                height={36}
                className={styles.profileImage}
              />
            </Menu.Target>
            <Menu.Dropdown>
              <Menu.Item leftSection={<IconArrowBarRight size={12} />} onClick={() => signOut()}>
                Sign out
              </Menu.Item>
            </Menu.Dropdown>
          </Menu>
        </Group>

        <Burger opened={opened} onClick={toggle} hiddenFrom="sm" size="sm" />
      </Container>
    </header>
  );
}
